import React from 'react'
import { BullseyeIcon } from 'src/components/common'
import ThresholdIndicator from './ThresholdIndicator'

export default function SetValueIndicator(props) {
  return <ThresholdIndicator thresholdFieldName="setValue" i18n="WEB_RULE" icon={BullseyeIcon} {...props} />
}
